import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const RepublicCompactLogoIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="9"
    fill="none"
    {...props}
    viewBox="0 0 91 104"
  >
    <path
      fill="#0049FF"
      d="M89.977 98.673 64.826 59.25a31.2 31.2 0 0 0 11.419-8.82 31.06 31.06 0 0 0 6.858-19.443C83.103 13.9 69.203 0 52.115 0H3.465A3.47 3.47 0 0 0 0 3.465v97.07A3.47 3.47 0 0 0 3.465 104h83.593a3.465 3.465 0 0 0 2.921-5.33zM52.115 6.706c13.388 0 24.282 10.894 24.282 24.282 0 5.61-1.858 10.878-5.372 15.234a24.47 24.47 0 0 1-9.854 7.301L31.301 6.706zM37.638 54.572l8.11-12.751 8.135 12.75zm4.7 6.706v36.016h-31.87l22.907-36.016h8.965zM6.705 6.706h16.641L41.77 35.582l-12.078 18.99H6.706zm18.72 54.572L6.706 90.715V61.28h18.72zm23.618 36.016V61.278h9.12l22.978 36.016z"
    />
  </ChakraIcon>
);
